<template>
    <div class="dashboard-body-futuristic">
        <SuperAdminSidebar />
        <SuperAdminHeader />
        <main class="futuristic-container">
            <!-- Main Content Card -->
            <section class="dashboard-card-futuristic dashboard-card-scrollable">
                <router-view></router-view>
            </section>
        </main>
    </div>
</template>

<script>
import SuperAdminSidebar from './SuperAdminSidebar.vue'
import SuperAdminHeader from './SuperAdminHeader.vue'

export default {
    name: 'SuperAdminLayout',
    components: {
        SuperAdminSidebar,
        SuperAdminHeader
    }
}
</script>
